let uniqueId = 0;

export default {
  uniqueId: null,

  beforeCreate() {
    this.uniqueId = uniqueId.toString();
    uniqueId += 1;
  },
};